<script>
export default {
    name: "MoveCampusModal",
    data() {
        return {
            selectedCampus: this.$store.state.data.selectedCampus.id,
            campuses: [],
        };
    },
    methods: {
        async getData(){
            this.$store.state.decrypt.campusAccessList().forEach((item) => {
                this.campuses.push({
                    id: item.Id,
                    campusName: item.CampusName,
                    shortName: item.ShortName,
                    isExternal: item.IsExternal,
                });
            });
        },
        async moveCampusSubmit() {
            this.$emit("moveCampus", this.selectedCampus);
        },
    },
};
</script>
<template>
    <b-modal
        id="move-campus-modal"
        title="Move to another Campus"
        size="md"
        title-class="font-18"
        hide-footer
        no-close-on-backdrop
    >
        <form @submit.prevent="moveCampusSubmit" class="needs-validation">
            <div class="mb-3">
                <label for="cycle">Select Campus </label>
                <select class="form-select" v-model="selectedCampus">
                    <option v-for="y in campuses" :key="y.id" :value="y.id">{{y.campusName}}</option>
                </select>
            </div>
            <div class="modal-footer">
                <button type="submit" class="btn btn-primary">
                    Transfer
                </button>
                <button
                    type="button"
                    class="btn btn-link"
                    @click="$bvModal.hide('move-campus-modal')"
                >
                    Close
                </button>
            </div>
        </form>
    </b-modal>
</template>